import { useTypedSelector } from 'hooks'
import { getParameterByName } from 'utils'
import { MagicAuthHandler } from './MagicAuthHandler'
import { useCallback, useEffect, useState } from 'react'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

export const MagicAuth = (props: Props) => {
  const { isAuthenticated, isVerifying } = useTypedSelector(({ auth }) => auth)
  const authToken = getParameterByName('authToken')
  const [token, setToken] = useState<string | null>(null)

  const getToken = useCallback(() => {
    if (isVerifying) return
    if (!!authToken && !isAuthenticated) setToken(authToken)
  }, [authToken, isVerifying, isAuthenticated])

  useEffect(() => {
    getToken()
  }, [getToken])

  if (!token) return <>{props.children}</>

  return <MagicAuthHandler token={token} {...props} />
}
